module.exports = __webpack_public_path__ + "static/media/versace-eau-fraiche-man-big.969d4484.png";